<template>
  <b-row class="mb-3">
    <b-col cols="11">
      <div class="d-inline-block">
        <p v-if="bank_name" class="text-monospace mb-0">
          <span>{{ bank_name }} </span>
        </p>

        <p v-if="routing_number || account_number" class="text-monospace mb-0">
          <span v-if="routing_number">
            {{ routing_number }}
          </span>
          <span v-if="account_number" class="pl-2">
            {{ account_number }}
          </span>
        </p>

        <p v-if="bank_address" class="text-monospace mb-0">
          <small>{{ bank_address }} </small>
        </p>

        <p v-if="residential_address" class="text-monospace mb-0">
          <small>{{ residential_address }} </small>
        </p>

        <p v-if="full_name" class="text-monospace mb-0">
          <span>{{ full_name }} </span>
        </p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'BankDetails',
  props: [
    'bank_name',
    'routing_number',
    'account_number',
    'residential_address',
    'bank_address',
    'full_name',
  ],
}
</script>

<style scoped>
.bank-icon {
  max-width: 35px !important;
  padding-right: 0;
}
</style>
